const scope = {
    name_exists: 'Bu kapsam adı {{name}} zaten kullanımda',
    name_with_space: 'Kapsam adı boşluk içeremez.',
};
export default scope;
